var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopTenRedeemChart'),_c('SpendingTotalPeriodChart'),_c('TransactionPerDayChart'),_c('AverageSpendingPerHeadChart'),_c('AverageSpendingPerTicketChart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }